/* Musk de Lumiere - The House Stack
 *
 * Two jobs, both defensive.
 *
 * 1. STAMP INK.
 *    The Eurus theme paints headings and links through `color` AND
 *    `-webkit-text-fill-color` with `!important`. A stylesheet cannot reliably
 *    beat that, and -webkit-text-fill-color wins over color regardless of
 *    specificity. Inline styles set with the 'important' priority flag DO win,
 *    so every element whose colour matters gets stamped inline here.
 *    This is why the last build rendered 1.07 contrast type. It cannot recur:
 *    if this script never runs, the CSS fallbacks are already correct, and if
 *    the theme repaints, the timed ladder stamps over it again.
 *
 * 2. ONE FADE.
 *    A single reveal on banner type, with a hard safety net so nothing can be
 *    left permanently invisible.
 */
(function () {
  var root = document.documentElement;
  var PAPER = '#FBFAF8';
  var INK   = '#121110';
  var WHITE = '#FFFFFF';

  function force(el, prop, val) {
    if (el && el.style) el.style.setProperty(prop, val, 'important');
  }

  function ink(el, colour) {
    force(el, 'color', colour);
    force(el, '-webkit-text-fill-color', colour);
    force(el, 'background-image', 'none');
  }

  function stampScope(scope, colour) {
    if (!scope) return;
    ink(scope, colour);
    var els = scope.querySelectorAll('h1,h2,h3,h4,p,span,a,li,div,input,button,label');
    for (var i = 0; i < els.length; i++) {
      // never repaint the button on hover-fill: it manages its own colours
      if (els[i].classList && els[i].classList.contains('mdl-btn')) continue;
      ink(els[i], colour);
    }
  }

  function stampButtons() {
    var b = document.querySelectorAll('.mdl-btn:not(.mdl-btn--ink)');
    for (var i = 0; i < b.length; i++) {
      force(b[i], '-webkit-text-fill-color', 'currentColor');
      force(b[i], 'background-image', 'none');
    }
    var bi = document.querySelectorAll('.mdl-btn--ink');
    for (var j = 0; j < bi.length; j++) {
      force(bi[j], '-webkit-text-fill-color', 'currentColor');
      force(bi[j], 'background-image', 'none');
    }
  }

  /* The cart drawer lives INSIDE the header section but runs its own colour
     system, including a solid ink Check out button. Stamping ink through the
     header therefore painted that button's label black on black and the button
     read as an empty rectangle. Never enter the drawer. */
  var NO_STAMP = '.mdlh__cd, .mdlcs';

  function offLimits(el) {
    return !!(el && el.closest && el.closest(NO_STAMP));
  }

  /* Belt and braces for anything else in the header that carries its own dark
     ground. Ink on a dark chip is the same bug wearing a different class name. */
  function darkGround(el) {
    var m = getComputedStyle(el).backgroundColor.match(/rgba?\(([^)]+)\)/);
    if (!m) return false;
    var p = m[1].split(/[,\s\/]+/).filter(Boolean).map(Number);
    if (p.length > 3 && p[3] < 0.5) return false;
    return (0.2126 * p[0] + 0.7152 * p[1] + 0.0722 * p[2]) / 255 < 0.45;
  }

  /* THE VIDEO HERO.
     On a page that opens with the film the bar is laid over it, so the paper
     ground and the hairline under it both have to be released. The TYPE does
     not change and the logo does not invert: every frame of that film is pale
     mist at the top, and the hero paints a paper veil under the bar to
     guarantee it. So ink stays ink, and only the ground is let go.

     The announcement bar is the exception. Its type is a pale cream chosen to
     sit on its own warm ground, and with that ground gone it would be cream on
     mist, which is nothing at all. It gets stamped ink like everything else.

     The section sets this class before paint. If it never runs, none of the
     below happens and the header behaves exactly as it always did. */
  function clearBar() { return root.classList.contains('mdl-hero-page'); }

  function releaseGround(hdr) {
    if (!clearBar()) return;    // nothing is ever forced on a page without the film
    var groups = document.querySelectorAll('.shopify-section-group-header-group');
    for (var i = 0; i < groups.length; i++) {
      force(groups[i], 'background-color', 'transparent');
      force(groups[i], 'border-bottom-color', 'transparent');
      if (groups[i] === hdr) continue;   // the bar's own type is stamped below
      var kids = groups[i].querySelectorAll('div,section,ul,li,p,span,a,button,svg');
      for (var j = 0; j < kids.length; j++) {
        if (offLimits(kids[j])) continue;
        force(kids[j], 'background-color', 'transparent');
        ink(kids[j], INK);
      }
    }
  }

  function stampHeader() {
    var hdr = document.querySelector('.shopify-section-header-mdl');
    if (!hdr) return;
    var clear = clearBar();

    force(hdr, 'background-color', clear ? 'transparent' : PAPER);
    releaseGround(hdr);

    var els = hdr.querySelectorAll('.mdlh__link, .mdlh__icon, .mdlh__logotext, .mdlh__col-h, .mdlh__sub, a, span, button');
    for (var i = 0; i < els.length; i++) {
      if (offLimits(els[i]) || darkGround(els[i])) continue;
      ink(els[i], INK);
    }

    var bars = hdr.querySelectorAll('.mdlh__burger span');
    for (var k = 0; k < bars.length; k++) force(bars[k], 'background', INK);

    var counts = hdr.querySelectorAll('.mdlh__count');
    for (var c = 0; c < counts.length; c++) {
      force(counts[c], 'background', INK);
      ink(counts[c], PAPER);
    }

    var logos = hdr.querySelectorAll('.mdlh__logo img');
    for (var l = 0; l < logos.length; l++) {
      force(logos[l], 'filter', 'brightness(0)');   // never inverted: the ground is always pale
      force(logos[l], 'opacity', '.92');
    }

    /* The hero has to know how tall the bar is so it can lie underneath it.
       Measured rather than guessed, because the logo width is a setting. */
    if (clear) {
      var groups = document.querySelectorAll('.shopify-section-group-header-group');
      var h = 0;
      for (var g = 0; g < groups.length; g++) h += groups[g].offsetHeight;
      if (h > 0) root.style.setProperty('--mdl-hdr-h', h + 'px');
    }
  }

  function stampAll() {
    var i, n;

    n = document.querySelectorAll('.mdl-b__inner');
    for (i = 0; i < n.length; i++) {
      var pale = n[i].parentNode && n[i].parentNode.classList.contains('mdl-b--ink');
      stampScope(n[i], pale ? INK : WHITE);
    }

    n = document.querySelectorAll('.mdl-row--dark, .mdl-sign');
    for (i = 0; i < n.length; i++) stampScope(n[i], PAPER);

    n = document.querySelectorAll('.mdl-row:not(.mdl-row--dark)');
    for (i = 0; i < n.length; i++) stampScope(n[i], INK);

    n = document.querySelectorAll('.mdl-vh__inner');
    for (i = 0; i < n.length; i++) stampScope(n[i], WHITE);

    stampButtons();
    stampHeader();
  }

  function initFade() {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = document.querySelectorAll('.mdl-fade');
    if (!els.length || reduced || !('IntersectionObserver' in window)) return;

    root.classList.add('js-mdl');

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('is-in');
          io.unobserve(entries[i].target);
        }
      }
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });

    for (var i = 0; i < els.length; i++) io.observe(els[i]);

    // hard safety net. legibility beats a fade, always.
    window.setTimeout(function () {
      var left = document.querySelectorAll('.mdl-fade:not(.is-in)');
      for (var j = 0; j < left.length; j++) left[j].classList.add('is-in');
    }, 3000);
  }

  function boot() {
    stampAll();
    initFade();
    // the theme rewrites colours after its own scripts hydrate
    var t = [50, 180, 500, 1100, 2200, 4000];
    for (var i = 0; i < t.length; i++) window.setTimeout(stampAll, t[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', stampAll);
  window.addEventListener('resize', stampHeader);
  document.addEventListener('shopify:section:load', boot);
})();
